import { action } from 'mobx';
import RoleModel from '../models/RoleModel';
import BaseStore from './BaseStore';
import * as api from '../actions/api';

class RoleStore extends BaseStore {
  constructor(transportLayer) {
    super(RoleModel, transportLayer);
  }

  @action fetchPermissions(roleId) {
    this.isLoading = true;

    return api.role.fetchPermissions(roleId)
      .then((items) => {
        this.isLoading = false;
        return items;
      })
      .catch(err => {
        this.isLoading = false;
        console.log('err', err);
      });
  }
}

export default RoleStore;



// WEBPACK FOOTER //
// ./src/stores/RoleStore.js